<template>
  <div class="content-wrapper view-doctor-dashboard pt-3 px-0">
    <div class="content">
      <div class="row ml-0" style="max-width: 100%">
        <div class="col-md-5">
          <!-- month calendar -->
          <div class="h100-lg">
            <div class="table-sticky-top">
              <b-card no-body>
                <b-collapse id="doctorCalendar" v-model="isCalendarOpen">
                  <div class="row">
                    <div class="col-12">
                      <b-calendar
                        v-model="dateDefault"
                        class="col border rounded p-1"
                        locale="th-TH"
                        :hide-header="true"
                        block
                      ></b-calendar>
                    </div>
                  </div>
                </b-collapse>
              </b-card>
              <div class="col-12 p-0">
                <!-- table queue treatment -->
                <b-card no-body>
                  <b-table
                    class="mb-0 tx-queue-table"
                    hover
                    small
                    sort-icon-left
                    outlined
                    no-border-collapse
                    sort-by="checkinDt"
                    sticky-header="100%"
                    :items="tableCheckinList"
                    :fields="tableHeaders"
                    head-variant="light"
                    @row-clicked="rowClick"
                    :tbody-tr-class="rowClass + ' border-bottom'"
                  >
                    <template v-slot:cell(index)="row"
                      ><span class="q-idx">{{ row.index + 1 }}.</span></template
                    >
                    <template v-slot:cell(title)="row">
                      <div class="q-name">{{ row.item.nameTh }}</div>
                      <div v-if="row.item.txTitle" class="q-sub">
                        {{ row.item.txTitle }}
                      </div>
                    </template>
                    <template v-slot:cell(checkinNote)="row">
                      <div v-if="row.item.checkinNote" class="q-note">
                        {{ row.item.checkinNote }}
                      </div>
                      <span v-else class="q-note-empty">-</span>
                    </template>
                    <template v-slot:cell(start)="row">
                      <span class="q-time">{{
                        checkTimeAppointment(row.item)
                      }}</span>
                    </template>
                    <template v-slot:cell(checkinDt)="row">
                      <span class="q-time">{{
                        row.item.checkinDt
                          ? formatTime(row.item.checkinDt)
                          : "-"
                      }}</span>
                    </template>
                    <template v-slot:cell(checkinStatus)="row">
                      <span
                        class="status-pill"
                        :class="{
                          'pill-onTime': row.value == 1,
                          'pill-early': row.value == 2,
                          'pill-late': row.value == 3,
                          'pill-walkIn': row.value == 4,
                        }"
                        >{{ row.item.checkinStatusName }}</span
                      >
                      <img
                        v-if="row.item.isNhso"
                        class="ml-1"
                        style="width: auto; height: 16px"
                        :src="NHSOLogo"
                      />
                    </template>
                    <template v-slot:head(welcome)>
                      <b-button
                        variant="outline-primary"
                        size="sm"
                        class="welcome-btn welcome-open-btn"
                        :class="{
                          'welcome-btn--active':
                            welcomeOpened && activeWelcomeId === null,
                        }"
                        v-b-tooltip.hover.bottom="{
                          container: 'body',
                          boundary: 'window',
                        }"
                        title="เปิดหน้าจอต้อนรับ"
                        @click="openWelcomeDisplay"
                      >
                        <i class="fas fa-desktop"></i>
                      </b-button>
                    </template>
                    <template v-slot:cell(welcome)="row">
                      <b-button
                        variant="outline-primary"
                        size="sm"
                        class="welcome-btn"
                        :class="{
                          'welcome-btn--active':
                            welcomeOpened && row.item.id === activeWelcomeId,
                        }"
                        v-b-tooltip.hover.right="{
                          container: 'body',
                          boundary: 'window',
                        }"
                        title="แสดงหน้าจอต้อนรับ"
                        @click.stop="showWelcome(row.item)"
                      >
                        <i class="fas fa-desktop"></i>
                      </b-button>
                    </template>
                  </b-table>
                  <div v-if="isNoQueue" class="text-muted text-center p-2">
                    ไม่มีคิวรอตรวจ
                  </div>
                </b-card>
                <b-collapse
                  id="dashboardNotation"
                  class="pb-1"
                  v-model="isCalendarOpen"
                >
                  <AdsCard v-if="showAds"></AdsCard>
                </b-collapse>
              </div>
            </div>
          </div>
        </div>
        <div id="doctorCalendar" class="col">
          <div class="row">
            <div class="col-12">
              <b-card body-class="p-2">
                <fullCalendar
                  ref="calendar"
                  defaultView="resourceTimeGridDay"
                  :themeSystem="themeSystem"
                  height="auto"
                  :defaultDate="dateDefault"
                  :header="header"
                  :titleFormat="titleFormat"
                  :minTime="openingTime"
                  :maxTime="closingTime"
                  :slotDuration="slotDuration"
                  :plugins="calendarPlugins"
                  timeZone="Asia/Bangkok"
                  :locale="locales"
                  :slotLabelFormat="slotLabelFormat"
                  :resources="getDoctorRooms"
                  :events="doctorAppointmentList"
                  :droppable="false"
                  :editable="false"
                  :selectable="false"
                  :eventDurationEditable="false"
                  :nowIndicator="true"
                  :schedulerLicenseKey="schedulerLicenseKey"
                  :customButtons="customButtons"
                  :scrollTime="scrollTime"
                  :allDaySlot="false"
                  :handleWindowResize="true"
                  @windowResize="fcWindowResize"
                  @eventClick="fcAppointmentClick"
                  :eventRender="renderCalendarEvents"
                  :viewSkeletonRender="onViewSkeletonRender"
                ></fullCalendar>
              </b-card>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- modal dialog -->
    <CustomerModal
      ref="customerModal"
      @openProfileCustomerModal="openProfileCustomerModal"
    ></CustomerModal>
    <searchCustomerModal
      ref="searchCustomerModal"
      @openProfileCustomerModal="openProfileCustomerModal"
      @openCustomerModal="openCustomerModal"
    ></searchCustomerModal>
    <ProfileCustomerModal
      ref="profileCustomerModal"
      @openCustomerModal="openCustomerModal"
    ></ProfileCustomerModal>
    <NextVisitModal ref="nextVisitModal"></NextVisitModal>
    <PaymentHistoryModal
      ref="paymentHistoryModal"
      mode="doctor"
      :tableCheckinList="tableCheckinList"
    ></PaymentHistoryModal>
    <ColorSidebar ref="colorSidebar" />
    <Dialog ref="Dialog"></Dialog>
    <Notification></Notification>

    <CariesRiskModal ref="cariesRiskModal" />

    <div id="appointmentPopover" class="d-none">
      <div v-if="lastFcAppointmentSelected">
        <div v-if="isPatientOne" class="row">
          <div class="col d-flex">
            <div class="align-self-stretch small-text">
              <p class="mb-1 mt-1">
                {{ lastFcAppointmentSelected.extendedProps.treatmentPeriod }}
                <i class="fas fa-info" id="appointment-info"></i>
              </p>
              <hr class="my-1" />

              <h6 class="narrow-spacing mb-0">
                <strong>
                  คนไข้ใหม่
                  <br />
                  ไม่มีประวัติ
                </strong>
              </h6>
              <hr class="my-1" />
              <p class="mb-1 narrow-spacing">
                แพทย์:
                {{ lastFcAppointmentSelected.extendedProps.doctorName }}
              </p>
              <p class="mb-1 narrow-spacing">
                <strong
                  v-html="
                    lastFcAppointmentSelected.extendedProps.treatmentTitle
                  "
                ></strong>
              </p>
              <p
                class="mb-1 narrow-spacing"
                v-if="lastFcAppointmentSelected.extendedProps.note"
              >
                โน๊ต: {{ lastFcAppointmentSelected.extendedProps.note }}
              </p>
              <b-button
                v-if="lastFcAppointmentSelected.extendedProps.rmdId"
                id="btnReminder"
                ref="btnReminder"
                class="border-0 mb-1"
                block
                :style="{
                  'background-color': findReminderObj(
                    lastFcAppointmentSelected.extendedProps.rmdId
                  ).desc,
                }"
                size="sm"
                disabled
              >
                {{
                  findReminderObj(lastFcAppointmentSelected.extendedProps.rmdId)
                    .label
                }}
              </b-button>
              <b-button
                id="btnStatus"
                ref="btnStatus"
                class="border-0"
                block
                :style="{
                  'background-color':
                    lastFcAppointmentSelected.extendedProps.statusColor,
                }"
                size="sm"
                disabled
              >
                {{
                  findStatusName(
                    lastFcAppointmentSelected.extendedProps.statusId
                  ).label
                }}
              </b-button>
            </div>
          </div>
        </div>
        <div v-else-if="isPatientNull" class="row">
          <div class="col d-flex">
            <div class="align-self-stretch small-text">
              <p class="mb-1 mt-1">
                {{ lastFcAppointmentSelected.extendedProps.treatmentPeriod }}
                <i class="fas fa-info" id="appointment-info"></i>
              </p>
              <hr class="my-1" />
              <p
                class="mb-1 narrow-spacing"
                v-if="lastFcAppointmentSelected.extendedProps.note"
              >
                <strong>{{
                  lastFcAppointmentSelected.extendedProps.note
                }}</strong>
              </p>
              <p
                class="mb-1 narrow-spacing"
                v-if="lastFcAppointmentSelected.extendedProps.doctor"
              >
                แพทย์: {{ lastFcAppointmentSelected.extendedProps.doctorName }}
              </p>
            </div>
          </div>
        </div>
        <div
          v-else-if="lastFcAppointmentSelected.extendedProps.linkedWithMFD"
          class="row"
        >
          <div class="col-7 pl-3 pr-0 d-flex">
            <div class="align-self-stretch small-text">
              <p class="mb-1 mt-1">
                {{ lastFcAppointmentSelected.extendedProps.treatmentPeriod }}
                <i class="fas fa-info" id="appointment-info"></i>
              </p>
              <hr class="my-1" />
              <p class="mb-0">
                DN: {{ lastFcAppointmentSelected.extendedProps.dn }}
              </p>
              <p
                v-if="lastFcAppointmentSelected.extendedProps.existDn"
                class="mb-1 description text-muted"
              >
                DN(เดิม):
                {{ lastFcAppointmentSelected.extendedProps.existDn }}
              </p>
              <p
                v-if="
                  lastFcAppointmentSelected.extendedProps.patient.titleNameTh
                "
                class="mb-0"
              >
                {{
                  lastFcAppointmentSelected.extendedProps.patient.titleNameTh
                }}
              </p>
              <h6 class="narrow-spacing mb-0">
                <strong>
                  {{
                    lastFcAppointmentSelected.extendedProps.patient.firstNameTh
                  }}
                  <br />
                  {{
                    lastFcAppointmentSelected.extendedProps.patient.lastNameTh
                  }}
                </strong>
              </h6>
              <p
                class="norrow-spacing mb-0"
                v-if="lastFcAppointmentSelected.extendedProps.patient.dob"
              >
                อายุ:
                {{
                  calAge(lastFcAppointmentSelected.extendedProps.patient.dob)
                }}
                ปี
              </p>
              <hr class="my-1" />
              <p class="mb-1 narrow-spacing">
                โทร: {{ lastFcAppointmentSelected.extendedProps.phoneNo }}
              </p>
              <hr class="my-1" />
              <p class="mb-1 narrow-spacing">
                แพทย์:
                {{ lastFcAppointmentSelected.extendedProps.doctorName }}
              </p>
              <p class="mb-1 narrow-spacing">
                <strong
                  v-html="
                    lastFcAppointmentSelected.extendedProps.treatmentTitle
                  "
                ></strong>
              </p>
              <p
                class="mb-1 narrow-spacing"
                v-if="lastFcAppointmentSelected.extendedProps.note"
              >
                โน๊ต: {{ lastFcAppointmentSelected.extendedProps.note }}
              </p>
              <b-button
                v-if="lastFcAppointmentSelected.extendedProps.rmdId"
                id="btnReminder"
                ref="btnReminder"
                class="border-0 mb-1"
                block
                :style="{
                  'background-color': findReminderObj(
                    lastFcAppointmentSelected.extendedProps.rmdId
                  ).desc,
                }"
                size="sm"
              >
                {{
                  findReminderObj(lastFcAppointmentSelected.extendedProps.rmdId)
                    .label
                }}
              </b-button>
              <b-button
                id="btnStatus"
                ref="btnStatus"
                class="border-0"
                block
                :disabled="
                  [5, 6, 7, 8].includes(
                    lastFcAppointmentSelected.extendedProps.statusId
                  )
                "
                :style="{
                  'background-color':
                    lastFcAppointmentSelected.extendedProps.statusColor,
                }"
                size="sm"
              >
                {{
                  findStatusName(
                    lastFcAppointmentSelected.extendedProps.statusId
                  ).label
                }}
              </b-button>
            </div>
          </div>
          <div class="col-5 d-flex justify-content-end">
            <b-button-group vertical class="align-self-stretch">
              <b-button id="btnMorFunDee" variant="primary">
                <img style="width: auto; height: 26px" :src="MorFunDeeLogo" />
                <br />
                Mor <br />
                Fun <br />Dee
              </b-button>
              <b-button id="btnCopyLink" variant="secondary">
                <i class="fas fa-copy"></i>
                <br />
                Copy Link
              </b-button>

              <b-button id="btnPatientDetail" class="btn btn-info">
                <i class="fas fa-info"></i>
                <br />ประวัติ
              </b-button>
            </b-button-group>
          </div>
        </div>
        <div v-else class="row">
          <div class="col-7 pl-3 pr-0 d-flex">
            <div class="align-self-stretch small-text">
              <p class="mb-1">
                {{ lastFcAppointmentSelected.extendedProps.treatmentPeriod }}
                <i class="fas fa-info" id="appointment-info"></i>
              </p>
              <hr class="my-1" />
              <p class="mb-0">
                DN: {{ lastFcAppointmentSelected.extendedProps.dn }}
              </p>
              <p
                v-if="lastFcAppointmentSelected.extendedProps.existDn"
                class="mb-1 description text-muted"
              >
                DN(เดิม):
                {{ lastFcAppointmentSelected.extendedProps.existDn }}
              </p>
              <p
                v-if="
                  lastFcAppointmentSelected.extendedProps.patient.titleNameTh
                "
                class="mb-0"
              >
                {{
                  lastFcAppointmentSelected.extendedProps.patient.titleNameTh
                }}
              </p>
              <h6 class="narrow-spacing mb-0">
                <strong>
                  {{
                    lastFcAppointmentSelected.extendedProps.patient.firstNameTh
                  }}
                  <br />
                  {{
                    lastFcAppointmentSelected.extendedProps.patient.lastNameTh
                  }}
                </strong>
              </h6>
              <p
                class="norrow-spacing mb-0"
                v-if="lastFcAppointmentSelected.extendedProps.patient.dob"
              >
                อายุ:
                {{
                  calAge(lastFcAppointmentSelected.extendedProps.patient.dob)
                }}
                ปี
              </p>
              <hr class="my-1" />

              <p class="mb-1 narrow-spacing">
                แพทย์:
                {{ lastFcAppointmentSelected.extendedProps.doctorName }}
              </p>
              <p class="mb-1 narrow-spacing">
                <strong
                  v-html="
                    lastFcAppointmentSelected.extendedProps.treatmentTitle
                  "
                ></strong>
              </p>
              <p
                v-if="lastFcAppointmentSelected.extendedProps.note"
                class="mb-1 narrow-spacing"
              >
                <strong>
                  โน๊ต:
                  {{ lastFcAppointmentSelected.extendedProps.note }}
                </strong>
              </p>
              <b-button
                v-if="lastFcAppointmentSelected.extendedProps.rmdId"
                id="btnReminder"
                ref="btnReminder"
                class="border-0 mb-1"
                block
                disabled
                :style="{
                  'background-color': findReminderObj(
                    lastFcAppointmentSelected.extendedProps.rmdId
                  ).desc,
                }"
                size="sm"
              >
                {{
                  findReminderObj(lastFcAppointmentSelected.extendedProps.rmdId)
                    .label
                }}
              </b-button>
              <b-button
                id="btnStatus"
                ref="btnStatus"
                class="border-0"
                block
                disabled
                :style="{
                  'background-color':
                    lastFcAppointmentSelected.extendedProps.statusColor,
                }"
                size="sm"
              >
                {{
                  findStatusName(
                    lastFcAppointmentSelected.extendedProps.statusId
                  ).label
                }}
              </b-button>
            </div>
          </div>
          <div class="col-5 d-flex justify-content-end">
            <b-button-group vertical class="align-self-stretch">
              <button
                v-if="isQueuePayment"
                id="btnCancelPayment"
                class="btn btn-warning"
                :disabled="!isTodayApt"
              >
                <i class="fas fa-redo"></i>
                <br />ยกเลิก <br />ชำระเงิน
              </button>
              <button
                v-else
                id="btnPaymentHistory"
                class="btn btn-success"
                title="บันทึกการรักษาได้ เมื่ออยู่ในคิวรอตรวจเท่านั้น"
                :disabled="!isTodayApt || !isCheckIn"
              >
                <i class="fa fa-save" aria-hidden="true"></i>
                <br />บันทึก <br />รักษา
              </button>
              <button id="btnPatientDetail" class="btn btn-info">
                <i class="fa fa-info-circle" aria-hidden="true"></i>
                <br />ประวัติ <br />คนไข้
              </button>
            </b-button-group>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="extendedProps"
      id="doctor-dashboard-appointment-detail"
      class="d-none"
    >
      <div class="small-text">
        <div class="small">
          สร้างโดย:
          <div class="text-muted">
            {{ getUserListBy(extendedProps.creationUid, "uid").fullName }}
            <br />
            {{ formatDateTime(extendedProps.creationDt) }}<br />
          </div>
        </div>
        <div v-if="isAptModified" class="small">
          แก้ไขโดย:
          <div clss="text-muted">
            {{ getUserListBy(extendedProps.modifyUid, "uid").fullName }}<br />
            {{ formatDateTime(extendedProps.modifyDt) }}
          </div>
        </div>
      </div>
    </div>

    <!-- Floating Audio Transcribe Button -->
    <div class="floating-audio-transcribe">
      <AudioTranscribeButton
        ref="audioTranscribeButton"
        :value="transcriptionText"
        @input="updateTranscriptionText"
        @transcription-started="handleTranscriptionStarted"
        @transcription-chunk="handleTranscriptionChunk"
        @transcription-complete="handleTranscriptionComplete"
        @transcription-error="handleTranscriptionError"
        @transcription-cancelled="handleTranscriptionCancelled"
        @open-history="handleOpenHistory"
      />
    </div>

    <!-- Audio Transcription Modal -->
    <AudioTranscriptionModal
      v-model="showTranscriptionModal"
      :transcription-text="transcriptionText"
      :is-transcribing="isTranscribing"
      @message="handleModalMessage"
    />

    <Loading v-if="isLoading"></Loading>
    <AdsPopup v-if="showAds" ref="adsPopup" />
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import { eventBus } from "../main";

import CustomerModal from "@/components/modal/Customer";
import SearchCustomerModal from "@/components/modal/SearchCustomer";
import ProfileCustomerModal from "@/components/modal/ProfileCustomer";
import PaymentHistoryModal from "@/components/modal/PaymentHistory";
import NextVisitModal from "@/components/modal/NextVisit";
import CariesRiskModal from "@/components/modal/CariesRiskAssesment";
import AudioTranscribeButton from "@/components/button/AudioTranscribe";
import AudioTranscriptionModal from "@/components/modal/AudioTranscriptionModal";

//** ห้ามเอา import bootstrap ออก ถ้าออกจะทำให้ popover error (คิดว่าถูกเรียกใช้ใน jquery) */
import bootstrap from "bootstrap";

import ColorSidebar from "@/components/menubar/ColorSidebar";
import AdsPopup from "@/components/modal/AdsPopup";

import Dialog from "@/components/modal/Dialog";
import Notification from "@/components/Notification";
import Loading from "@/components/Loading";

import moment from "moment";
import fullCalendar from "@fullcalendar/vue";
import interaction, { Draggable } from "@fullcalendar/interaction";
import fcBootstrap from "@fullcalendar/bootstrap";
import resourceTimeGridPlugin from "@fullcalendar/resource-timegrid";
import momentTimezonePlugin from "@fullcalendar/moment-timezone";
import locales from "@fullcalendar/core/locales/th";
import AdsCard from "@/components/Ads";
import MorFunDeeLogo from "../assets/img/morfundee-logo.png";
import NHSOLogo from "../assets/img/NHSO_logo.png";
import buildWelcomePayload from "@/utils/buildWelcomePayload";
import {
  openWelcomeQueue,
  publishWelcomeQueue,
  publishWelcomeCommand,
  subscribeWelcomeQueue,
} from "@/utils/welcomeChannel";

import $ from "jquery";
import "@/theme/DoctorDashboard.scss";

export default {
  name: "QueueManage",
  components: {
    CustomerModal,
    SearchCustomerModal,
    ProfileCustomerModal,
    PaymentHistoryModal,
    NextVisitModal,

    CariesRiskModal,
    AudioTranscribeButton,
    AudioTranscriptionModal,

    fullCalendar,
    Dialog,
    Notification,
    Loading,
    ColorSidebar,
    AdsCard,
    AdsPopup,
  },
  data() {
    return {
      // Audio Transcription State
      transcriptionText: "",
      showTranscriptionModal: false,
      isTranscribing: false,

      isLoading: false,
      // True once the doctor has opened the welcome display this session, so the
      // queue watcher knows to keep relaying live updates to that window.
      welcomeOpened: false,
      // appointmentId currently shown on the welcome screen (null = general),
      // mirrored from the board's selection reports to highlight its row button.
      activeWelcomeId: null,
      welcomeUnsub: null,
      appointmentTempData: null,
      themeSystem: "bootstrap",
      displayPage: false,
      dateDefault: moment().format("YYYY-MM-DD"),
      dateShower: false,
      schedulerLicenseKey: "0650622495-fcs-1679632464",
      locales: locales,
      slotLabelFormat: {
        hour: "2-digit",
        minute: "2-digit",
        omitZeroMinute: false,
        meridiem: "short",
      },
      slotDuration: "00:15",
      header: {
        left: "prevDay,todayButton,nextDay toggleSidebar",
        center: "title",
        right: "",
      },
      titleFormat: {
        month: "long",
        year: "2-digit",
        day: "numeric",
        weekday: "short",
      },
      calendarPlugins: [
        interaction,
        resourceTimeGridPlugin,
        fcBootstrap,
        momentTimezonePlugin,
      ],
      windowHeight: window.innerHeight,
      fetchEventTimeout: 0,
      tableHeaders: [
        {
          key: "index",
          label: "",
          class: "text-center",
        },
        {
          label: "คิวรอตรวจ",
          key: "title",
        },
        {
          label: "ข้อความ",
          key: "checkinNote",
        },
        {
          label: "สถานะ",
          sortable: true,
          key: "checkinStatus",
        },
        {
          label: "นัด",
          sortable: true,
          key: "start",
          class: "text-nowrap",
        },
        {
          label: "มาถึง",
          sortable: true,
          key: "checkinDt",
          class: "text-nowrap",
        },
        {
          label: "",
          key: "welcome",
          class: "text-center",
        },
      ],
      lastFcAppointmentSelected: null,
      isTodayApt: true,
      isCheckIn: true,
      popEl: null,
      isCalendarOpen: true,
      MorFunDeeLogo,
      NHSOLogo,
    };
  },
  created() {
    this.init();
  },
  watch: {
    dateDefault: function (date) {
      this.getDoctorAppointmentListByDate(date);
      this.setStateDoctorDate(date);
      this.getCalendarApi().gotoDate(date);
    },
    lastFcAppointmentSelected() {
      this.isTodayApt = moment().isSame(
        this.lastFcAppointmentSelected.start,
        "day"
      );
      this.isCheckIn =
        this.lastFcAppointmentSelected.extendedProps.statusId === 5;
    },
    // Push every websocket-driven queue change to the open welcome window so its
    // patient list (and arrow navigation) stays live. Selection is preserved on
    // the receiver because publishWelcomeQueue omits activeId.
    welcomePatients() {
      this.relayWelcomeQueue();
    },
    welcomeClinic() {
      this.relayWelcomeQueue();
    },
  },
  computed: {
    ...mapGetters({
      roomList: "moduleUser/getRoomList",
      branchInfo: "moduleUser/getBranchInfo",
      doctorAppointmentList: "moduleAppointment/getDoctorAppointmentList",
      doctorCheckInList: "moduleAppointment/getDoctorCheckInList",
      appointmentBy: "moduleAppointment/getDoctorAppointmentBy",
      getAppointmentStatusList: "moduleMaster/getAppointmentStatusList",
      getReminderList: "moduleMaster/getReminderList",
      userInfo: "moduleUser/getUserInfo",
      getUserListBy: "moduleUser/getUserListBy",
      viewFile: "moduleContent/viewFile",
      // Whether this branch's plan should show ads at all — shared with
      // QueueManage.vue via moduleBranch so both screens apply the exact same
      // rule (see stores/branch.js). Gates the AdsCard/AdsPopup render below
      // and the programmatic adsPopup.show() call in mounted(); the
      // fetch/cache-serve itself is already gated upstream in
      // services/adsSource.js and composables/useAdsCache.js so a PREMIUM
      // branch never requests, caches, renders, or tracks an ad.
      showAds: "moduleBranch/showAds",
    }),
    // Clinic branding for the welcome board's general (no-patient) screen.
    welcomeClinic() {
      const clinic = this.branchInfo?.clinic || {};
      return {
        clinicName: clinic.name || "",
        clinicNameEn: clinic.nameEn || null,
        clinicLogoUrl:
          clinic.logo && typeof this.viewFile === "function"
            ? this.viewFile(clinic.logo)
            : null,
      };
    },
    // The whole คิวรอตรวจ queue as welcome payloads, ordered by check-in time to
    // mirror the table's default sort so the welcome board's up/down navigation
    // matches what the doctor sees.
    welcomePatients() {
      return [...this.doctorCheckInList]
        .sort((a, b) => {
          const da = a.extendedProps?.checkin?.checkinDt || "";
          const db = b.extendedProps?.checkin?.checkinDt || "";
          return da < db ? -1 : da > db ? 1 : 0;
        })
        .map((appt) =>
          buildWelcomePayload(appt, {
            branchInfo: this.branchInfo,
            roomList: this.roomList,
            viewFile: this.viewFile,
          })
        );
    },
    // slotDuration() {
    //   return this.branchInfo?.confApptDuration
    //     ? this.branchInfo.confApptDuration
    //     : "00:15";
    // },
    openingTime() {
      return this.branchInfo?.confOpeningTime
        ? this.branchInfo.confOpeningTime
        : "09:00";
    },
    closingTime() {
      return this.branchInfo?.confClosingTime
        ? this.branchInfo.confClosingTime
        : "21:00";
    },
    fullCalendarHeight() {
      return this.windowHeight - 80;
    },
    customButtons() {
      return {
        prevDay: {
          text: "prev",
          bootstrapFontAwesome: "fa-chevron-left",
          click: () => {
            this.dateDefault = moment(this.dateDefault)
              .add(-1, "days")
              .format("YYYY-MM-DD");
          },
        },
        todayButton: {
          text: "วันนี้",
          click: () => {
            this.dateDefault = moment().format("YYYY-MM-DD");
          },
        },
        nextDay: {
          text: "next",
          bootstrapFontAwesome: "fa-chevron-right",
          click: () => {
            this.dateDefault = moment(this.dateDefault)
              .add(1, "days")
              .format("YYYY-MM-DD");
          },
        },
        collapseCalendar: {
          text: "Collapse",
          bootstrapFontAwesome: "angle-double-up",
          click: () => {
            this.isCalendarOpen = !this.isCalendarOpen;
          },
        },
        toggleSidebar: {
          text: "toggle",
          bootstrapFontAwesome: "fa-sliders-h",
          click: () => {
            this.$refs.colorSidebar.toggle({ slotDuration: this.slotDuration });
          },
        },
      };
    },
    scrollTime() {
      return moment().format("HH:mm:ss");
    },
    getDoctorRooms() {
      const doctorAppointmentList = this.doctorAppointmentList;
      const roomList = this.roomList;
      let rooms = roomList.filter(room => {
        const found = doctorAppointmentList.findIndex(event => {
          return event.resourceId == room.id;
        });
        return found != -1;
      });

      if (rooms.length == 0) {
        return [
          {
            id: 0,
            title: "ไม่พบนัดหมาย",
          },
        ];
      } else {
        return rooms;
      }
    },
    isQueuePayment() {
      if (this.lastFcAppointmentSelected) {
        return this.lastFcAppointmentSelected.extendedProps.statusId === 6
          ? true
          : false;
      } else {
        return false;
      }
    },
    isNoQueue() {
      return this.doctorCheckInList.length === 0;
    },
    isToday() {
      return moment().isSame(this.dateDefault, "day");
    },
    tableCheckinList: {
      get() {
        if (this.doctorCheckInList.length === 0) {
          return [];
        } else {
          return this.doctorCheckInList.map(item => {
            return {
              id: item.id,
              title:
                item.extendedProps.patientName +
                "\n" +
                item.extendedProps.treatmentTitle,
              nameTh: item.extendedProps.patientName,
              dn: item.extendedProps.dn,
              txTitle: item.extendedProps.treatmentTitle,
              start: item.start,
              checkinDt: item.extendedProps.checkin.checkinDt,
              checkinStatus: item.extendedProps.checkin.checkinStatus,
              checkinStatusName: item.extendedProps.checkin.checkinStatusName,
              checkinNote: item.extendedProps.checkin.checkinNote,
              isNhso: item.extendedProps.nhsoVisitBookingNo ? true : false,
              _rowVariant: "",
              blink: false,
            };
          });
        }
      },
    },
    isPatientOne() {
      return this.lastFcAppointmentSelected?.extendedProps?.patient?.id == 1;
    },
    isPatientNull() {
      return !this.lastFcAppointmentSelected?.extendedProps?.patient?.id;
    },
    extendedProps() {
      return this.lastFcAppointmentSelected?.extendedProps;
    },
    isAptModified() {
      if (!this.extendedProps.modifyDt) return false;
      if (this.extendedProps.creationDt === this.extendedProps.modifyDt)
        return false;
      return true;
    },
  },
  methods: {
    ...mapActions({
      setStateDoctorDate: "moduleAppointment/setStateDoctorDate",
      fetchDoctorAppointmentList:
        "moduleAppointment/fetchDoctorAppointmentList",
      fetchDoctorCheckInList: "moduleAppointment/fetchDoctorCheckInList",
      cancelWaitingForPaymentAppointment:
        "moduleAppointment/cancelWaitingForPaymentAppointment",
    }),
    init() {
      this.isLoading = true;

      this.getDoctorAppointmentListByDate(this.dateDefault);

      this.setStateDoctorDate(this.dateDefault);
    },
    offJQuery() {
      $(document).off("click", "#btnMorFunDee");
      $(document).off("click", "#btnCopyLink");
      $(document).off("click", "#btnPaymentHistory");
      $(document).off("click", "#btnPatientDetail");
      $(document).off("click", "#btnCancelPayment");
      $(document).off("click", "#btnCreatePatient");
      $(document).off("click", "#btnSearchPatient");
      $(document).off("click.hidePopover");
      $(document).off("mouseenter", "#appointment-info");
      $(document).off("mouseleave", "#appointment-info");
    },
    onJQuery() {
      const self = this;
      $(document).on("click", "#btnPaymentHistory", () => {
        const appointment = this.appointmentBy(
          this.lastFcAppointmentSelected.id,
          "id"
        );
        self.openPaymentHistoryModal(appointment);
        self.hidePopOver();
      });
      $(document).on("click", "#btnCancelPayment", () => {
        const appointment = this.appointmentBy(
          this.lastFcAppointmentSelected.id,
          "id"
        );
        self.$refs.Dialog.showAlertConfirm(
          "ยกเลิกส่งชำระเงิน ?",
          "คุณต้องการยกเลิกการส่งชำระเงิน",
          "warning",
          "ใช่",
          "ไม่"
        ).then(result => {
          if (result.value) {
            self.isLoading = true;
            self
              .cancelWaitingForPaymentAppointment({
                id: appointment.id,
                clinicUrl: self.$route.params.clinicUrl,
                branchUrl: self.$route.params.branchUrl,
              })
              .finally(() => {
                self.isLoading = false;
              });
          }
        });

        // function ยกเลิกคิวชำระเงิน เข้ามาอยู่ใน คิวรอตรวจ แต่ *ห้ามลบ treatment และ appointmentDraft ที่เคยบันทึกไป
      });

      $(document).on("click", "#btnPatientDetail", () => {
        const patient = this.lastFcAppointmentSelected.extendedProps.patient;
        const appointment = this.appointmentBy(
          this.lastFcAppointmentSelected.id,
          "id"
        );
        self.openProfileCustomerModal(appointment, patient, true);
        self.hidePopOver();
      });
      $(document).on("click", "#btnMorFunDee", () => {
        window
          .open(
            this.lastFcAppointmentSelected.extendedProps
              .mfdAppointmentMeetingUrl + "&mode=dentist",
            "_blank"
          )
          .focus();
        self.hidePopOver();
      });
      $(document).on("click", "#btnCopyLink", async () => {
        try {
          await navigator.clipboard.writeText(
            `${this.lastFcAppointmentSelected.extendedProps.mfdClipboradText}`
          );
          eventBus.$emit("alertToast", {
            message: "บันทึกใส่คลิปบอร์ดสำเร็จ",
            variant: "success",
          });
        } catch (error) {
          console.error(error);
          eventBus.$emit("alertToast", {
            message: "บันทึกใส่คลิปบอร์ดไม่สำเร็จ",
            variant: "warning",
          });
        }
      });

      //close popover when click outside
      $(document).on("click.hidePopover", e => {
        if (
          self.popEl &&
          !$(self.popEl).is(e.target) &&
          $(self.popEl).has(e.target).length === 0 &&
          $(".popover").has(e.target).length === 0
        ) {
          self.hidePopOver();
        }
      });

      $(document).on("mouseenter", "#appointment-info", async e => {
        Vue.nextTick().then(res => {
          let el = $(e.target)
            .popover({
              content: () => $("#doctor-dashboard-appointment-detail").html(),
              placement: "right",
              boundary: "scrollParent",
              boundaryPadding: 2,
              delay: 500,
              offset: 0,
              triggers: "",
              html: true,
              // container: "#doctorCalendar",
              sanitize: false,
            })
            .popover("show");
        });
        $(document).on("mouseleave", "#appointment-info", async e => {
          $(e.target).popover("hide");
        });
      });
    },
    getDoctorAppointmentListByDate(date, silent = false) {
      if (!silent) this.isLoading = true;
      if (!date) date = this.dateDefault;
      this.fetchDoctorAppointmentList({
        clinicUrl: this.$route.params.clinicUrl,
        branchUrl: this.$route.params.branchUrl,
        date: date,
        uid: this.userInfo.uid,
      })
        .then(res => {
          this.isLoading = false;
        })
        .catch(err => {
          this.isLoading = false;
        });
    },
    openCustomerModal(patient, appointment, readOnly) {
      this.$refs.customerModal.show(patient, appointment, readOnly);
    },
    openSearchCustomerModalNoSelect() {
      this.$refs.searchCustomerModal.show();
    },
    openProfileCustomerModal(appointment, patient, hideFooter, mode) {
      this.$refs.profileCustomerModal.show(
        appointment,
        patient,
        hideFooter,
        mode
      );
    },
    openPaymentHistoryModal(appointment) {
      this.$refs.paymentHistoryModal.show(appointment);
    },
    openNextVisitModal(apt, pt) {
      this.$refs.nextVisitModal.show(apt, pt);
    },
    openTreatmentSummaryModal(apt) {
      this.$refs.treatmentSummaryModal.show(apt);
    },
    renderCalendarEvents(info) {
      function shadeColor(color, percent) {
        var R = parseInt(color.substring(1, 3), 16);
        var G = parseInt(color.substring(3, 5), 16);
        var B = parseInt(color.substring(5, 7), 16);

        R = parseInt((R * (100 + percent)) / 100);
        G = parseInt((G * (100 + percent)) / 100);
        B = parseInt((B * (100 + percent)) / 100);

        R = R < 255 ? R : 255;
        G = G < 255 ? G : 255;
        B = B < 255 ? B : 255;

        R = Math.round(R / 10) * 10;
        G = Math.round(G / 10) * 10;
        B = Math.round(B / 10) * 10;

        var RR =
          R.toString(16).length == 1 ? "0" + R.toString(16) : R.toString(16);
        var GG =
          G.toString(16).length == 1 ? "0" + G.toString(16) : G.toString(16);
        var BB =
          B.toString(16).length == 1 ? "0" + B.toString(16) : B.toString(16);

        return "#" + RR + GG + BB;
      }

      let eventProps = info.event.extendedProps;
      const fcTime = info.el.getElementsByClassName("fc-time")[0];

      if (eventProps.patient?.id) {
        fcTime.classList.add("sideStatus");

        if (eventProps.statusId === 7) {
          info.el.style.backgroundColor = "#e0e0e0";
        } else if (eventProps.patient.id === 1) {
          info.el.classList.add("fc-unnamed-patient");
          info.el.style.backgroundColor = shadeColor(
            eventProps.doctorColor,
            -5
          );
        } else {
          info.el.style.backgroundColor = eventProps.doctorColor;
        }
        info.el.style.borderColor = eventProps.doctorColorBorder;
        fcTime.style.backgroundColor = eventProps.statusColor;
      } else {
        info.el.classList.add("fc-note-event");
        info.el.style.backgroundColor = "#5a6268";
        fcTime.style.display = "none";
      }

      if (info.event.id == this.blinkAptId) {
        info.el.classList.add("blink");
        setTimeout(() => info.el.classList.remove("blink"), 60000);
      }
      if (eventProps.patient?.isLinkedWithDentcare === true) {
        $(info.el).append(
          `<i class="fas fa-link" style="position: absolute; top: 2px; right: 2px; color: #5a9fd4; font-size: 12px; z-index: 1;"></i>`
        );
      } else if (eventProps.patient?.isLinkedWithDentcare === false) {
        $(info.el).append(
          `<i class="fas fa-unlink" 
             data-toggle="tooltip" 
             data-placement="top" 
             title="ไม่ได้เชื่อมต่อกับ DentCare"
             style="position: absolute; top: 2px; right: 2px; color: #6c757d; opacity: 0.5; font-size: 12px; z-index: 1;">
           </i>`
        );
        // Initialize tooltip for the newly added unlink icon
        $(info.el.querySelector(".fas.fa-unlink")).tooltip();
      }
      if (eventProps.linkedWithMFD) {
        $(info.el.querySelector(".fc-title")).prepend(
          `<img class="mr-1 rounded" style="width: auto; height: 16px" src="${MorFunDeeLogo}"/ >`
        );
      } else if (eventProps.nhsoVisitBookingNo) {
        $(info.el.querySelector(".fc-title")).prepend(
          `<img class="mr-1 rounded" style="width: auto; height: 16px" src="${NHSOLogo}"/ >`
        );
      } else if (eventProps.rmdId) {
        let rmdObj = this.findReminderObj(eventProps.rmdId);
        $(info.el.querySelector(".fc-title")).prepend(
          `<span class="mr-1 px-1 rounded" style="color: white; background-color: ${rmdObj.desc}">${rmdObj.code}</span>`
        );
      }
    },
    onViewSkeletonRender() {
      $("#calendar .fc-view-container").css({ "overflow-x": "auto" });
      $("#calendar .table-bordered").css(
        "min-width",
        $(".fc-resource-cell").length * 110
      );
    },
    fcAppointmentClick(info) {
      this.lastFcAppointmentSelected = Object.assign(info.event);
      this.popEl = info.el;
      this.hidePopOver();
      Vue.nextTick().then(function () {
        $(info.el)
          .popover({
            content: () => $("#appointmentPopover").html(),
            placement: "left",
            boundary: "scrollParent",
            boundaryPadding: 5,
            delay: { show: 500, hide: 100 },
            offset: 0,
            triggers: "",
            html: true,
            container: "body",
            sanitize: false,
          })
          .popover("show");
      });
    },
    fcWindowResize(arg) {
      this.windowHeight = window.innerHeight;
    },
    hidePopOver() {
      $(".popover").not(this).popover("hide");
    },
    getCalendarApi() {
      return this.$refs.calendar.getApi();
    },
    checkTimeAppointment(data) {
      return data.checkinStatus != "04" ? this.formatTime(data.start) : "-";
    },
    formatTime(date) {
      return moment(date).format("HH:mm");
    },
    setToday() {
      this.dateDefault = moment().format("YYYY-MM-DD");
    },
    showDialogToast(variant, textDetail, noAutoHide) {
      this.$refs.Dialog.showToast(variant, textDetail, noAutoHide);
    },
    // Per-row button: open the welcome board focused on this patient.
    showWelcome(item) {
      const appointment = this.appointmentBy(item.id, "id");
      if (!appointment || !appointment.id) {
        this.showDialogToast("danger", "ไม่พบข้อมูลนัดหมายของผู้ป่วย");
        return;
      }
      this.welcomeOpened = true;
      this.activeWelcomeId = item.id;
      const opened = openWelcomeQueue({
        clinic: this.welcomeClinic,
        patients: this.welcomePatients,
        activeId: item.id,
      });
      this.warnIfPopupBlocked(opened);
    },
    // Header button: open the welcome board on the general welcome screen
    // (activeId null). Works even when the queue is empty.
    openWelcomeDisplay() {
      this.welcomeOpened = true;
      this.activeWelcomeId = null;
      const opened = openWelcomeQueue({
        clinic: this.welcomeClinic,
        patients: this.welcomePatients,
        activeId: null,
      });
      this.warnIfPopupBlocked(opened);
    },
    // Arrow keys on the dashboard remote-control the open welcome board,
    // mirroring its own keys (up/down = patient, left/right = post-op screens).
    // Ignored while typing in a field or when no welcome window is open.
    onWelcomeKeydown(e) {
      if (!this.welcomeOpened) return;
      const t = e.target;
      if (
        t &&
        (t.tagName === "INPUT" ||
          t.tagName === "TEXTAREA" ||
          t.tagName === "SELECT" ||
          t.isContentEditable)
      ) {
        return;
      }
      const action = {
        ArrowDown: "next",
        ArrowUp: "prev",
        ArrowRight: "postopNext",
        ArrowLeft: "postopPrev",
      }[e.key];
      if (!action) return;
      e.preventDefault();
      publishWelcomeCommand(action);
    },
    // Relay live queue/clinic changes to an already-open welcome window.
    relayWelcomeQueue() {
      if (!this.welcomeOpened) return;
      publishWelcomeQueue({
        clinic: this.welcomeClinic,
        patients: this.welcomePatients,
      });
    },
    warnIfPopupBlocked(opened) {
      if (!opened) {
        this.showDialogToast(
          "warning",
          "เบราว์เซอร์บล็อกการเปิดหน้าต่างใหม่ กรุณาอนุญาต pop-up แล้วลองอีกครั้ง"
        );
      }
    },
    rowClick(row, index) {
      if (!this.isToday) return;

      const appointment = this.appointmentBy(row.id, "id");
      this.openPaymentHistoryModal(appointment);
    },
    setBgColor() {
      this.tableCheckinList.forEach(item => {
        let diff = moment().diff(item.checkinDt, "minutes");
        if (diff <= 8) {
          item._rowVariant = "green";
        } else if (diff <= 15) {
          item._rowVariant = "lightGreen";
        } else if (diff <= 30) {
          item._rowVariant = "yellow";
        } else if (diff <= 40) {
          item._rowVariant = "lightRed";
        } else if (diff <= 45) {
          item._rowVariant = "red";
        } else if (diff > 45) {
          item._rowVariant = "purple";
        }
      });
    },
    findStatusName(statusId) {
      return this.getAppointmentStatusList.find(function (item) {
        return item["code"] == statusId;
      });
    },
    findReminderObj(rmdId) {
      return this.getReminderList.find(function (item) {
        return item["val"] == rmdId;
      });
    },
    blinkMe(e) {
      let index = this.tableCheckinList.findIndex(i => i.id == e.id);
      if (index == -1) return;
      let item = this.tableCheckinList[index];
      item.blink = true;
      this.$set(this.tableCheckinList, index, item);

      setTimeout(() => {
        let index = this.tableCheckinList.findIndex(i => i.id == e.id);
        if (index == -1) return;
        let item = this.tableCheckinList[index];
        item.blink = false;
        this.$set(this.tableCheckinList, index, item);
      }, 6000);
    },
    rowClass(item, type) {
      let isBlink, isCursorNotAllowed;
      if (!item || type !== "row") return;
      item.blink ? (isBlink = "blink") : (isBlink = "");
      this.isToday
        ? (isCursorNotAllowed = "")
        : (isCursorNotAllowed = "cursor-not-allowed");
      return isBlink + " " + isCursorNotAllowed;
    },
    calAge(dateString) {
      if (!dateString) return;
      const date = moment(dateString, "YYYY-MM-DD");
      return moment().diff(date, "years");
    },
    formatDateTime(date) {
      if (!date) return "N/A";
      return moment(date)?.locale("th").format("lll") || "N/A";
    },

    // Audio Transcription Methods
    updateTranscriptionText(text) {
      this.transcriptionText = text;
    },

    handleTranscriptionStarted() {
      this.setTranscriptionState(true);
      this.showTranscriptionModal = true;
    },

    handleTranscriptionChunk(chunk) {
      this.setTranscriptionState(true);
      // Modal is already shown when transcription starts
    },

    handleTranscriptionComplete() {
      this.setTranscriptionState(false);
      this.showSuccessMessage("การแปลงเสียงเป็นข้อความเสร็จสิ้น");
    },

    handleTranscriptionError(error) {
      this.setTranscriptionState(false);
      this.ensureModalIsVisible();
      this.showErrorMessage(
        "เกิดข้อผิดพลาดในการแปลงเสียงเป็นข้อความ: " + error
      );
    },

    handleTranscriptionCancelled() {
      this.setTranscriptionState(false);
      this.transcriptionText = "";
    },

    // Transcription Helper Methods
    setTranscriptionState(isTranscribing) {
      this.isTranscribing = isTranscribing;
    },

    ensureModalIsVisible() {
      if (!this.showTranscriptionModal) {
        this.showTranscriptionModal = true;
      }
    },

    showSuccessMessage(message) {
      this.$refs.dialog?.a("success", message);
    },

    showErrorMessage(message) {
      this.$refs.dialog?.a("danger", message);
    },

    handleModalMessage(message) {
      if (this.$refs.dialog) {
        this.$refs.dialog.a(message.type, message.text);
      }
    },

    setupGlobalKeyboardShortcuts() {
      this.globalKeyHandler = event => {
        // Ctrl/Cmd + Shift + M - Toggle audio recording
        if (
          (event.ctrlKey || event.metaKey) &&
          event.shiftKey &&
          event.key.toLowerCase() === "m"
        ) {
          event.preventDefault();
          // Use component ref to trigger audio recording
          if (this.$refs.audioTranscribeButton) {
            if (this.$refs.audioTranscribeButton.isRecording) {
              this.$refs.audioTranscribeButton.stopRecording();
            } else {
              this.$refs.audioTranscribeButton.startRecording();
            }
          }
        }
      };

      document.addEventListener("keydown", this.globalKeyHandler);
    },

    handleOpenHistory() {
      // Open transcription modal to view history
      this.showTranscriptionModal = true;
    },

    removeGlobalKeyboardShortcuts() {
      if (this.globalKeyHandler) {
        document.removeEventListener("keydown", this.globalKeyHandler);
        this.globalKeyHandler = null;
      }
    },
  },
  async mounted() {
    this.onJQuery();

    // Show ads popup — the ref only exists when showAds is true (v-if on
    // AdsPopup above); calling .show() unconditionally would throw on a
    // PREMIUM/AD_FREE branch where $refs.adsPopup is undefined.
    if (this.showAds) {
      try {
        await this.$refs.adsPopup.show();
      } catch (error) {
        console.error('Error showing ads popup:', error);
      }
    }
    eventBus.$on("openSearchCustomerModal", () => {
      this.$refs.searchCustomerModal.show();
    });
    eventBus.$on("slotDurationSetting", e => {
      this.slotDuration = e;
    });
    this.slotDuration =
      localStorage.getItem("fcSlotDuration") ||
      this.branchInfo.confApptDuration ||
      "00:15";

    eventBus.$on("blinkNewCheckIn", this.blinkMe);
    this.interval = setInterval(() => this.setBgColor(), 60000);

    eventBus.$on("fetch-queue-data", async () => {
      await this.$nextTick();
      this.getDoctorAppointmentListByDate(this.dateDefault, true);
    });

    // Setup keyboard shortcuts for audio transcription
    this.setupGlobalKeyboardShortcuts();

    // Arrow keys on the dashboard remote-control an open welcome board.
    window.addEventListener("keydown", this.onWelcomeKeydown);

    // Mirror the welcome board's current patient so its row button shows active.
    this.welcomeUnsub = subscribeWelcomeQueue((msg) => {
      if (msg && msg.type === "selection") this.activeWelcomeId = msg.activeId;
    });
  },
  destroyed() {
    this.offJQuery();
    this.hidePopOver();
    eventBus.$off("openSearchCustomerModal");
    eventBus.$off("slotDurationSetting");
    eventBus.$off("blinkNewCheckIn");
    eventBus.$off("fetch-queue-data");

    clearInterval(this.interval);

    // Remove keyboard shortcuts
    this.removeGlobalKeyboardShortcuts();
    window.removeEventListener("keydown", this.onWelcomeKeydown);
    if (this.welcomeUnsub) this.welcomeUnsub();
  },
  updated() {
    this.setBgColor();
  },
};
</script>

<style>
.floating-audio-transcribe {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1050; /* Above most Bootstrap components but below modals */
  pointer-events: none; /* Allow clicks to pass through the container */
}

.floating-audio-transcribe .audio-controls {
  pointer-events: auto; /* Re-enable clicks on the actual button */
  filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.15));
}

.floating-audio-transcribe .show-button-container {
  pointer-events: auto; /* Enable clicks on the show button */
}

.floating-audio-transcribe .audio-controls .audio-btn {
  width: 56px !important;
  height: 56px !important;
  border-radius: 50% !important;
  font-size: 20px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 2px solid rgba(255, 255, 255, 0.2) !important;
  backdrop-filter: blur(10px);
}

.floating-audio-transcribe .audio-controls .audio-btn:hover {
  transform: translateY(-2px) scale(1.05);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
}

.floating-audio-transcribe .audio-controls .audio-btn:active {
  transform: translateY(0) scale(0.98);
}

.floating-audio-transcribe .timer-display {
  background: rgba(0, 0, 0, 0.85) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  font-size: 12px !important;
  padding: 4px 8px !important;
  border-radius: 16px !important;
  color: white !important;
  text-align: center;
  min-width: 60px;
  margin-bottom: 8px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.floating-audio-transcribe .timer-warning {
  background: rgba(220, 53, 69, 0.9) !important;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .floating-audio-transcribe {
    bottom: 80px; /* Above mobile navigation if present */
    right: 15px;
  }

  .floating-audio-transcribe .audio-controls .audio-btn {
    width: 48px !important;
    height: 48px !important;
    font-size: 18px !important;
  }
}

/* Ensure the button doesn't interfere with scroll */
@media (max-height: 600px) {
  .floating-audio-transcribe {
    bottom: 15px;
  }
}

/* Animation for when transcription is active */
.floating-audio-transcribe .audio-controls .recording-pulse {
  animation: float-pulse 2s infinite ease-in-out;
}

@keyframes float-pulse {
  0% {
    box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3),
      0 0 0 0 rgba(220, 53, 69, 0.7);
  }
  50% {
    box-shadow: 0 6px 20px rgba(220, 53, 69, 0.4),
      0 0 0 15px rgba(220, 53, 69, 0);
  }
  100% {
    box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3), 0 0 0 0 rgba(220, 53, 69, 0);
  }
}
/* ===== คิวรอตรวจ compact table ===== */
/* Open-welcome button lives in the (otherwise empty) welcome column header and
   shares the row button's look (.welcome-btn) for cohesion — just more compact. */
.tx-queue-table .welcome-open-btn {
  font-size: 11.5px;
  font-weight: 600;
  padding: 0.2rem 0.65rem;
  white-space: nowrap;
}
.tx-queue-table table {
  font-size: 13.5px;
}
.tx-queue-table thead th {
  font-size: 12px;
  font-weight: 600;
  color: #6c757d;
  padding: 0.45rem 0.6rem;
  background: #fafbfc;
  border-bottom: 1px solid #e9ecef;
  vertical-align: middle;
}
.tx-queue-table td {
  padding: 0.28rem 0.55rem;
  vertical-align: middle;
}
.tx-queue-table .q-idx {
  color: #495057;
  font-size: 14px;
}
.tx-queue-table .q-name {
  font-weight: 500;
  font-size: 13.5px;
  line-height: 1.3;
}
.tx-queue-table .q-sub {
  color: #6c757d;
  font-size: 12.5px;
  line-height: 1.25;
}
.tx-queue-table .q-note {
  color: #343a40;
  font-size: 13px;
  line-height: 1.25;
}
.tx-queue-table .q-note-empty {
  color: #ced4da;
}
.tx-queue-table .q-time {
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  font-size: 14px;
}

/* status pills (colors from Base.scss) */
.tx-queue-table .status-pill {
  display: inline-block;
  font-size: 12.5px;
  font-weight: 600;
  padding: 3px 11px;
  border-radius: 999px;
  line-height: 1.5;
  white-space: nowrap;
}
.tx-queue-table .pill-onTime {
  background: #e1f5ef;
  color: #049372;
}
.tx-queue-table .pill-early {
  background: #e3f0fc;
  color: #1978d4;
}
.tx-queue-table .pill-late {
  background: #fbeede;
  color: #d47500;
}
.tx-queue-table .pill-walkIn {
  background: #fde6e4;
  color: #e63022;
}

/* show-welcome-screen button — soft-filled, lifts on hover */
.tx-queue-table .welcome-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: #e8f1fc;
  color: #1978d4;
  border-radius: 9px;
  padding: 0.4rem 0.65rem;
  line-height: 1;
  transition: background 0.15s ease, color 0.15s ease,
    box-shadow 0.15s ease, transform 0.15s ease;
}
.tx-queue-table .welcome-btn i {
  font-size: 16px;
}
.tx-queue-table .welcome-btn:hover,
.tx-queue-table .welcome-btn:focus {
  background: #1978d4;
  color: #fff;
  box-shadow: 0 3px 8px rgba(25, 120, 212, 0.35);
  transform: translateY(-1px);
}
.tx-queue-table .welcome-btn:active {
  transform: translateY(0);
  box-shadow: 0 1px 3px rgba(25, 120, 212, 0.3);
}
/* Persistent filled state for the patient currently on the welcome screen. */
.tx-queue-table .welcome-btn--active,
.tx-queue-table .welcome-btn--active:hover,
.tx-queue-table .welcome-btn--active:focus {
  background: #1978d4;
  color: #fff;
  box-shadow: 0 0 0 2px rgba(25, 120, 212, 0.35);
}
</style>
